






































import { Notificacao } from "@/services/central-notificacao.service";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DetalhesEventoRow extends Vue {
  @Prop({ type: Number, default: 1 }) colspan!: number;
  @Prop({ type: Object, required: true }) item!: Notificacao;
}
